import {PlayersStatisticsTableColumnApiModel} from "./players-statistics.table.column.api-model";
import {BaseDomainModel} from "../../../../../../infrastructure/models/base-domain-model";

export class PlayersStatisticsTableColumnDomainModel extends BaseDomainModel {
  apiModel: PlayersStatisticsTableColumnApiModel;

  get num(): Number {
    return this.apiModel.num;
  }

  get name(): String {
    return this.apiModel.name;
  }

  get shortName(): String {
    return this.apiModel.shortName;
  }

  get order(): Number {
    return this.apiModel.order;
  }

  get isMajor(): Boolean {
    return this.apiModel.isMajor;
  }

  get isGraphic(): Boolean {
    return this.apiModel.isGraphic;
  }

  get columnGroup(): Boolean {
    return this.apiModel.columnGroup;
  }
}
